module.exports = __webpack_public_path__ + "static/banner-medicals-d1beb80c074038b84dcb172b372c4979.png";